var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSex(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 154,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sex_svg__clip0_632_7544)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.426 18.528s5.696-6.138 10.414-1.636c6.625 6.335-2.661 12.636-2.661 12.636s4.533-4.05 8.717.719c4.149 4.722.662 15.827-6.916 15.281 0 0 .605 6.278-5.242 8.459-5.846 2.181-4.904-3.91-4.904-3.91L123.56 26.615l11.866-8.087z",
    fill: "#FF755F",
    stroke: "#FF755F",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.733 120.566l-2.93-15.467s9.636-25.19 18.411-30.191c5.742-3.273 9.043-2.449 9.345-2.379.012.012.023.012.023.012-.174-3.551.605-3.91 1.639-7.74.163-.591.256-1.3.302-2.088.291-4.398-.883-11.708-1.859-18.45-1.628-11.463 1.557-17.555 1.557-17.555 3.952-8.725 14.97-14.585 23.048-12.287 8.089 2.297 12.901 15.385 13.076 28.845.174 13.46-.698 21.454 1.72 24.552 2.406 3.098 12.738-3.806 17.887-1.09 5.161 2.738 17.446 23.809 14.947 45.205-1.836 15.931-97.166 8.633-97.166 8.633z",
    fill: "#fff",
    stroke: "#333",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.161 34.993c0-.279 1.976-6.277 5.846-8.088 3.871-1.821 6.16 1.265 7.183 3.957 1.651 4.363 2.627 15.548-9.403 22.139",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.161 34.993c0-.279 1.976-6.277 5.846-8.088 3.871-1.821 6.16 1.265 7.183 3.957 1.651 4.363 2.627 15.548-9.403 22.139",
    stroke: "#333",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.486 63.942c-1.151 8.006-9.403 15.641-18.457 18.008-8.52 2.228-13.483-1.207-15.145-3.632-2.452-3.562-1.825-9.131.221-13.483.256-.545.384-1.31.43-2.111 1.685.417 4.405.452 8.473-1.265 8.02-3.388 14.447-8.366 17.202-15.27 2.754-6.915.337-15.153 1.604-16.86 1.267-1.693 2.638 0 2.638 0 1.825 1.927 4.184 26.607 3.034 34.613z",
    fill: "#FF755F",
    stroke: "#FF755F",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.216 13.921c-4.382-4.246-.512-9.572 5.079-10.025 8.577-.696 8.298 10.025 8.298 10.025s4.278-8.644 10.019-3.376c4.777 4.386-1.72 14.353-1.72 14.353s2.406 9.19-5.509 8.459c-4.44-.407-3.952-7.728-3.952-7.728s.709 8.818-3.87 9.015c-5.568.244-4.382-6.08-4.382-6.08s-1.29 11.94-10.065 10.246c-5.486-1.068-4.301-6.277-4.301-6.277s-5.416 6.73-10.75 6.915c-5.336.186-8.532-5.755-6.638-12.09 1.895-6.335 10.508-5.36 10.508-5.36s-7.88-.86-3.371-8.703c6.544-11.406 20.654.626 20.654.626z",
    fill: "#FF755F",
    stroke: "#FF755F",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.694 42.175c0 .313.895 13.042 1.139 16.569.035.475.454.8.895.696l4.324-.986M111.517 46.271s3.266-4.548 8.426-3.365",
    stroke: "#333",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.816 44.971s-.174 4.34 1.662 4.108c1.895-.232 1.546-5.883 1.546-5.883s-1.337.65-3.208 1.775z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.081 50.146s1.778-2.471 4.777-3.295",
    stroke: "#333",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.349 48.754s-.035 3.991 1.511 3.724c1.592-.278 1.15-5.453 1.15-5.453s-1.104.638-2.661 1.729z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.846 41.513s7.857-3.492 11.96-.661M100.965 46.27s1.406-2.97 4.312-3.469M120.023 60.123s-3.927.674-5.064 4.96M137.404 38.496s1.906-3.968 5.103-4.931M138.613 44.774l1.337-9.689",
    stroke: "#333",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.291 125.485l-77.524 9.422c0-.603-.675-27.987 7.822-36.109 8.484-8.122 18.003-4.003 22.246-6.544 4.23-2.541 5.265-26.072 4.01-34.426-1.267-8.366 2.278-18.426 12.157-20.619 3.522-.777 7.276.72 10.495 3.516 3.476 3.04 6.335 7.611 7.613 12.496.128.5.256 1.01.372 1.532 2.36 9.897 3.255 22.858-1.871 29.866-3.44 4.711-8.24 3.76-8.24 3.76s-3.092 8.725-.57 12.357c2.522 3.643 19.747.429 23.49 24.749z",
    fill: "#fff",
    stroke: "#333",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.198 84.283s3.01 3.632 8.16 3.991M80.332 73.689l3.986-2.077c.117-.058.128-.232.024-.313-3.86-2.924-4.626-12.926-4.626-12.926",
    stroke: "#333",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.473 76.067c1.522-.255 4.16-1.531 4.602-.499.802 1.892-2.15 2.24-2.998 2.298-.128.011-.616 0-.744-.012-1.965-.278-3.661-1.09-3.813-1.717.744-.035 1.942.093 2.953-.07z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.095 67.736c.023-.116 2.464-5.604 6.427-5",
    stroke: "#333",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.16 63.978s-.255 3.713 1.174 3.759c1.697.046 2.011-5.024 2.011-5.024s-2.418-.22-3.185 1.265z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.925 61.819c.058-.093 2.034-3.818 4.87-3.76",
    stroke: "#333",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.03 59.394s-.348 3.006.675 3.435c1.337.545 1.86-4.758 1.86-4.758s-1.093.175-2.534 1.323zM69.896 66.17c.43-1.473 1.174-2.796 2.115-3.99a12.84 12.84 0 013.417-3.006.542.542 0 01.733.174.54.54 0 01-.175.731c-.011 0-.011.012-.023.012h-.012a11.932 11.932 0 00-3.3 2.599c-.93 1.056-1.72 2.309-2.186 3.62l-.011.023a.289.289 0 01-.372.174.258.258 0 01-.186-.336zM81.883 56.458c.57-.22 1.07-.302 1.616-.383a8.37 8.37 0 011.616-.058c1.069.058 2.208.406 3.022 1.206a.28.28 0 010 .407.288.288 0 01-.396.011l-.011-.011c-.71-.627-1.686-.882-2.65-.894a6.939 6.939 0 00-1.465.128c-.476.093-.988.209-1.371.383l-.023.011a.451.451 0 01-.593-.22.45.45 0 01.22-.592.09.09 0 00.035.012z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.975 44.53c1.453 1.717-.894 11.835-12.796 15.409-5.998 1.798 4.021 19.157-9.577 32.28-3.44 3.318-14.436 5.987-23.118 3.76-16.76-4.282-20.259-24.75-4.986-31.91 6.253-2.935 17.027 1.463 16.771-4.815-.395-9.619 14.831-36.979 33.706-14.724z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.495 54.741c-7.613-1.694-7.857-9.236-7.775-9.584l-.372-4.351.174-.093c3.475 3.04 6.334 7.612 7.613 12.497.116.51.244 1.02.36 1.531z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.377 70.197c.174-.14 1.662-7.693 1.278-8.621-.953-2.31-5.335 3.364-5.637 13.796-.302 10.43 4.359-5.175 4.359-5.175z",
    fill: "#fff",
    stroke: "#333",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.818 97.87s2.429-3.782 4.8-6.138c5.928-5.918 3.092-9.909 4.975-14.55 1.871-4.653 5.614-8.088 7.218-9.387 2.022-1.636 2.406-3.794-.186-3.04 0 0 1.824-1.694 1.708-2.9-.116-1.208-2.185-.511-2.185-.511s2.313-1.787 1.023-3.296c-.697-.812-2.941.569-3.243.755 0 0-.011 0-.011-.012.29-.325 2.894-3.295.755-3.632-1.581-.255-11.878 5.43-15.9 14.284l-8.508 21.848s-10.67 16.801-21.351 30.4c-6.451 8.215-15.017 12.659-17.016 16.72-3.335 6.788 19.689 16.674 30.847-2.146 6.462-10.919 12.913-24.077 17.074-38.395z",
    fill: "#fff",
    stroke: "#333",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.56 65.915s3.8-4.664 8.345-7.113l-8.345 7.113z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.56 65.915s3.8-4.664 8.345-7.113",
    stroke: "#333",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.209 68.804c.128-.058 6.52-6.648 8.926-7.46l-8.926 7.46z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.209 68.804c.128-.058 6.52-6.648 8.926-7.46",
    stroke: "#333",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.532 72.019c.082-.035 5.486-5.697 8.09-7.264l-8.09 7.264z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.532 72.019c.082-.035 5.486-5.697 8.09-7.264",
    stroke: "#333",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.98 84.176c.281-1.35 1.959-1.917 3.083-1.033 7.694 6.02 33.203 22.664 71.025 14.002 45.966-10.532 80.425 5.768 87.284 9.387.741.391 1.144 1.2.975 1.991L163.164 201 2.559 168.159l17.42-83.983z",
    fill: "#FF755F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.752 88.488c8.535 6.457 33.543 21.77 70.05 13.379 40.78-9.369 72.482 2.493 83.812 7.777",
    stroke: "#333",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sex_svg__clip0_632_7544"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h167v154H0z"
  })))));
}
export default __webpack_public_path__ + "static/sex.cc727488.svg";
export { SvgSex as ReactComponent };